<template>
  <div class="card flex justify-center">
    <PrimeDrawer
      :visible="visible"
      :header="header"
      :position="position"
      @update:visible="closeDrawer"
      :class="classes ? `${classes}` : ''">
      <slot></slot>
    </PrimeDrawer>
  </div>
</template>

<script>
import PrimeDrawer from 'primevue/drawer';
import Button from 'primevue/button';

export default {
  name: 'CustomDrawer',
  components: {
    PrimeDrawer,
    Button
  },
  props: [
    'visible',
    'header',
    'position',
    'classes'
  ],
  methods: {
    closeDrawer() {
      this.$emit('update:visible', false);
    }
  }
}
</script>